import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientesService } from "app/core/services/clientes/clientes.service";
import { columnHeader } from "app/shared/factoring-datatable/factoring-datatable.component";
import { ConfirmModalComponent } from "app/shared/utils/confirm-modal/confirm-modal.component";
import { AddLocalComponent } from "app/modules/clientes/modals/add-local/add-local.component";

@Component({
  selector: "app-business-information-locales-sucursales",
  templateUrl: "./locales-sucursales.component.html",
  styleUrls: ["./locales-sucursales.component.css"],
})
export class LocalesSucursalesComponent implements OnInit {
  public rowData: any[] = [];
  public loadingTable: boolean = false;
  public columnDefs: columnHeader[];
  public pageTableActual: number;
  public pageTableTotal: number;
  public pageTablePerPages: number = 10;
  public pageTablePages: number[];
  public searchstring: string = "";
  public moneda_valor_comercial: number = 2;

  @Input() clienteId = 0;
  @Input() readonly = false;

  constructor(
    private clientesService: ClientesService,
    public modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.obtenerLocales();
  }

  obtenerLocales(page = 1, page_size = 10) {
    this.clientesService
      .obtenerLocales(this.clienteId.toString(), page, page_size)
      .then((res) => {
        this.initVars();
        this.loadTable(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  loadTable(data) {
    this.rowData = data.results.map((el: any, i: number) => ({
      ...el,
      index: i + 1,
    }));
    this.pageTableActual = data.page_number;
    this.pageTableTotal = data.count;
    this.pageTablePerPages = data.per_page;
    this.pageTablePages = [];
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index);
    }
  }

  initVars() {
    let columns = [
      {
        headerName: "N°",
        field: "index",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Tipo Local",
        field: "tipo_local_nombre",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Dirección",
        field: "direccion",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Teléfono",
        field: "telefono",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Área Terreno m²",
        field: "area_terreno",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Área Construido m²",
        field: "area_construido",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Propio/Alquilado",
        field: "tipo_propiedad_nombre",
        sortable: true,
      },
      {
        headerName: "Gravado a favor de",
        field: "gravado_beneficiario",
        class: "text-center",
      },
      {
        headerName: "Valor Comercial US$",
        field: "valor_comercial",
        class: "text-center",
        pipe: "currency",
        moneda: "moneda_valor_comercial",
      },
    ];

    this.columnDefs = columns;
  }

  goToPage({ page, per_page, filtros }) {
    this.obtenerLocales(page, per_page);
  }

  tableEditEvent(local) {
    const modalRef = this.modalService.open(AddLocalComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;
    modalRef.componentInstance.localId = local.id;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerLocales();
      },
      (error) => {}
    );
  }

  destroyContact(local) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {});

    modalRef.componentInstance.title = "Remover Local / Sucursal";
    modalRef.componentInstance.message =
      "¿Seguro que desea remover el local / sucursal?";

    modalRef.result.then((result) => {
      if (result) {
        this.clientesService
          .eliminarLocal(local.id)
          .then((result) => {
            this.obtenerLocales();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  openModal() {
    const modalRef = this.modalService.open(AddLocalComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerLocales();
      },
      (error) => {}
    );
  }
}
